import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faHome,
  faBars,
  faTimes,
  faChevronDown,
  faChevronUp,
  faTrashAlt,
  faCalendarAlt,
  faFileDownload,
  faPhoneAlt,
  faUser,
  faEnvelope,
  faSearch,
  faSignOutAlt,
  faTachometerAlt,
  faGavel,
  faBuilding,
  faUserCircle,
  faIdCard,
  faClone,
  faHeart,
  faChartArea,
  faCalendarWeek,
  faCalendarDay,
  faCalendar,
  faEdit,
  faSignInAlt,
  faExclamationTriangle,
  faList,
  faReceipt,
  faEye,
  faFile,
  faCloudUploadAlt,
  faLink,
  faCloudDownloadAlt,
  faPrint,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileCsv,
  faFileAlt,
  faFileArchive,
  faPencilAlt,
  faChevronLeft,
  faChevronRight,
  faCartPlus,
  faCheckCircle,
  faSpinner,
  faClock,
  faPenAlt,
  faSyncAlt,
  faDownload,
  faShieldAlt,
  faLock,
  faQuestionCircle,
  faRedo,
} from '@fortawesome/free-solid-svg-icons'

import {} from '@fortawesome/free-regular-svg-icons'

import {
  faFacebook,
  faTwitter,
  faGoogle,
  faLinkedin,
  faGithub,
  faBitbucket,
  faPinterest,
  faWpforms,
} from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faHome,
  faFacebook,
  faTwitter,
  faGoogle,
  faLinkedin,
  faGithub,
  faBitbucket,
  faPinterest,
  faBars,
  faTimes,
  faChevronDown,
  faChevronUp,
  faTrashAlt,
  faCalendarAlt,
  faFileDownload,
  faPhoneAlt,
  faUser,
  faEnvelope,
  faSearch,
  faSignOutAlt,
  faTachometerAlt,
  faGavel,
  faBuilding,
  faUserCircle,
  faIdCard,
  faClone,
  faHeart,
  faChartArea,
  faCalendarWeek,
  faCalendarDay,
  faCalendar,
  faEdit,
  faSignInAlt,
  faExclamationTriangle,
  faList,
  faReceipt,
  faWpforms,
  faEye,
  faFile,
  faCloudUploadAlt,
  faLink,
  faCloudDownloadAlt,
  faPrint,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileCsv,
  faFileAlt,
  faFileArchive,
  faPencilAlt,
  faChevronLeft,
  faChevronRight,
  faCartPlus,
  faCheckCircle,
  faSpinner,
  faClock,
  faPenAlt,
  faSyncAlt,
  faDownload,
  faShieldAlt,
  faLock,
  faQuestionCircle,
  faRedo,
)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
